import * as React from 'react';
import { useMemo } from 'react';
import { isSameDay, parseISO } from 'date-fns';
import { useTranslation } from 'react-i18next';
import { format } from '../../../utils';

interface Props {
	timelimit: string;
}

const WaitingPaymentText: React.FC<Props> = ({ timelimit }) => {
	const { t: translateFunc } = useTranslation('FlightInfoCard');

	const now = useMemo(() => new Date(), []);
	const isToday = useMemo(() => {
		return isSameDay(parseISO(timelimit), now);
	}, [timelimit, now]);

	const t = (translateKey: string) => translateFunc(translateKey, { nsSeparator: '|' });

	if (isToday) {
		return (
			<>
				{t('The order must be paid today')} {format(timelimit, 'HH:mm')}
			</>
		);
	} else {
		return (
			<>
				{t('The order must be paid at')} {format(timelimit, 'HH:mm, dd.MM.yyyy')}
			</>
		);
	}
};

export default WaitingPaymentText;
